// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/pipeline.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CancelPipelineRunRequest, CancelPipelineRunResponse, CreatePipelineRequest, ExecutePipelineRequest, GetPipelineRequest, GetRunLogsRequest, GetRunLogsResponse, ListAllRunsRequest, ListEntityRunsRequest, ListEntityRunsResponse, ListPipelineRunsRequest, ListPipelineRunsResponse, ListPipelinesRequest, ListPipelinesResponse, ListRunEntitiesRequest, ListRunEntitiesResponse, Pipeline, PipelineStepResult, UpdatePipelineRequest } from "./pipeline_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.PipelineService
 */
export const PipelineService = {
  typeName: "omnios.v1.PipelineService",
  methods: {
    /**
     * @generated from rpc omnios.v1.PipelineService.CreatePipeline
     */
    createPipeline: {
      name: "CreatePipeline",
      I: CreatePipelineRequest,
      O: Pipeline,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PipelineService.GetPipeline
     */
    getPipeline: {
      name: "GetPipeline",
      I: GetPipelineRequest,
      O: Pipeline,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PipelineService.UpdatePipeline
     */
    updatePipeline: {
      name: "UpdatePipeline",
      I: UpdatePipelineRequest,
      O: Pipeline,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PipelineService.ListPipelines
     */
    listPipelines: {
      name: "ListPipelines",
      I: ListPipelinesRequest,
      O: ListPipelinesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Streaming execution -- emits step results as they complete
     *
     * @generated from rpc omnios.v1.PipelineService.ExecutePipeline
     */
    executePipeline: {
      name: "ExecutePipeline",
      I: ExecutePipelineRequest,
      O: PipelineStepResult,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc omnios.v1.PipelineService.ListPipelineRuns
     */
    listPipelineRuns: {
      name: "ListPipelineRuns",
      I: ListPipelineRunsRequest,
      O: ListPipelineRunsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * All runs across pipelines for the workspace (tasks page)
     *
     * @generated from rpc omnios.v1.PipelineService.ListAllRuns
     */
    listAllRuns: {
      name: "ListAllRuns",
      I: ListAllRunsRequest,
      O: ListPipelineRunsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PipelineService.GetRunLogs
     */
    getRunLogs: {
      name: "GetRunLogs",
      I: GetRunLogsRequest,
      O: GetRunLogsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PipelineService.CancelPipelineRun
     */
    cancelPipelineRun: {
      name: "CancelPipelineRun",
      I: CancelPipelineRunRequest,
      O: CancelPipelineRunResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lineage: entities produced by a run
     *
     * @generated from rpc omnios.v1.PipelineService.ListRunEntities
     */
    listRunEntities: {
      name: "ListRunEntities",
      I: ListRunEntitiesRequest,
      O: ListRunEntitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lineage: runs that produced/touched an entity
     *
     * @generated from rpc omnios.v1.PipelineService.ListEntityRuns
     */
    listEntityRuns: {
      name: "ListEntityRuns",
      I: ListEntityRunsRequest,
      O: ListEntityRunsResponse,
      kind: MethodKind.Unary,
    },
  }
};

